import { render, staticRenderFns } from "./stats-overview.vue?vue&type=template&id=6f3a8f50"
import script from "./stats-overview.vue?vue&type=script&lang=js"
export * from "./stats-overview.vue?vue&type=script&lang=js"
import style0 from "./stats-overview.vue?vue&type=style&index=0&id=6f3a8f50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports